import React, { useContext } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container, Row } from "reactstrap";

import "./Auth.css";
import { routesOffice } from "../../routes.js";
import { AuthContext } from "../../context/AuthContext";

const Auth = (props: any) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  // React.useEffect(() => {
  //   document.body.classList.add("bg-default");
  //   return () => {
  //     document.body.classList.remove("bg-default");
  //   };
  // }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
    if (mainContent.current) {
      //@ts-ignore
      mainContent.current.scrollTop = 0;
    }
  }, [location]);

  const getRoutes = (routes: any) => {
    return routes.map((prop: any, key: number) => {
      if (prop.layout === "/auth") {
        const relativePath = prop.path.startsWith("/")
          ? prop.path.slice(1)
          : prop.path;
        return (
          //@ts-ignore
          <Route path={relativePath} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  const isAuthLogin =
    location.pathname === "/auth/login" ||
    location.pathname === "/auth/register" ||
    location.pathname === "/auth/forgot-password" ||
    location.pathname === "/auth/reset-password" || location.pathname === "/auth/activeuser" || location.pathname === "/auth/activeuserinfo";

  return (
    <>
      <div
        // style={{ height: "100%" }}
        className={`bg-gradient-info-custom-bottom ${
          isAuthLogin ? "full-height" : ""
        }`}
        ref={mainContent}
      >
        <div className="bg-gradient-info-custom auth-header"></div>
        <Container className="position-card-login">
          <Row className="justify-content-center">
            {/* react-router-dom v6: basename — @types/react-router-dom v5 omits it */}
            {/* @ts-expect-error */}
            <Routes basename="/auth">
              {getRoutes(routesOffice)}
              <Route path="*" element={<Navigate to="/auth/login" replace />} />
            </Routes>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Auth;
